import { FC } from 'react';
import { Trans, useTranslation } from 'react-i18next';

import { Alert } from 'components/Display/Alert/Alert';
import { BasePopup } from 'components/Display/BasePopup/BasePopup';
import { Button } from 'components/Form/Button/Button';

type DeliverNewVersionConfirmationModalProps = {
  open: boolean;
  onConfirm: () => void;
  onCancel: () => void;
};

export const DeliverNewVersionConfirmationModal: FC<DeliverNewVersionConfirmationModalProps> = ({
  open,
  onConfirm,
  onCancel,
}) => {
  const { t } = useTranslation();

  return (
    <BasePopup open={open} setOpen={onCancel}>
      <BasePopup.Body>
        <h1 className="text-lg font-semibold text-gray-900">
          {t('transactions:show.sections.alert.review.documentChanged.confirmDeliverNewVersion.title')}
        </h1>
        <div className="mt-2 flex flex-col gap-6">
          <Alert
            severity="warning"
            withoutIcon
            title={t('transactions:show.sections.alert.review.documentChanged.confirmDeliverNewVersion.modalTitle')}
          >
            {
              <Trans i18nKey="transactions:show.sections.alert.review.documentChanged.confirmDeliverNewVersion.modalText" />
            }
          </Alert>
          <div className="flex items-center justify-end gap-2">
            <Button
              variant="secondary"
              onClick={onCancel}
              analyticsId="pending-review-banner-cancel-deliver-new-version"
            >
              {t('common:cancel')}
            </Button>
            <Button
              variant="primary"
              onClick={onConfirm}
              analyticsId="pending-review-banner-confirm-deliver-new-version"
            >
              {t('transactions:show.sections.alert.review.documentChanged.confirmDeliverNewVersion.actionTitle')}
            </Button>
          </div>
        </div>
      </BasePopup.Body>
    </BasePopup>
  );
};
